import { render, staticRenderFns } from "./NextMoveStart.vue?vue&type=template&id=17c323f7"
import script from "./NextMoveStart.vue?vue&type=script&lang=ts"
export * from "./NextMoveStart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports